import { render, staticRenderFns } from "./ModalListItems.vue?vue&type=template&id=63f5bb6d&scoped=true"
import script from "./ModalListItems.vue?vue&type=script&lang=ts"
export * from "./ModalListItems.vue?vue&type=script&lang=ts"
import style0 from "./ModalListItems.vue?vue&type=style&index=0&id=63f5bb6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f5bb6d",
  null
  
)

export default component.exports